import React from 'react';
import { SubTabs } from 'shared/components';
import { JvStatus } from 'views/Setting/common/model/jvStatus.model';

interface JvTabsProps {
  name: string;
  tab: JvStatus;
  onChange: (tab: JvStatus) => void;
}

const JvTab: React.FC<JvTabsProps> = (props) => {
  const { tab, onChange, name } = props;

  const checkSelectTab = (id: JvStatus) => {
    return id === tab && name === 'jv';
  };

  const selectTab = (index: JvStatus) => {
    onChange(index);
  };

  const tabs = [
    {
      id: JvStatus.USE,
      name: 'รายการ JV',
      color: 'badge-grey',
      count: 0,
      active: false,
      divider: false,
    },
  ].map((item) => ({
    id: item.id,
    name: item.name,
    count: item.count,
    active: checkSelectTab(item.id),
    clicked: () => selectTab(item.id),
    badgeClassName: checkSelectTab(item.id) ? item.color : null,
    divider: item.divider,
  }));

  return <SubTabs tabs={tabs} />;
};

export default JvTab;
